/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Filter_ApplyInputs */

const en_ui_filter_apply = /** @type {(inputs: Ui_Filter_ApplyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apply filter: ${i?.name}`)
};

const de_ui_filter_apply = /** @type {(inputs: Ui_Filter_ApplyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filter anwenden: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Apply filter: {name}" |
*
* @param {Ui_Filter_ApplyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_apply = /** @type {((inputs: Ui_Filter_ApplyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_ApplyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_apply(inputs)
	return de_ui_filter_apply(inputs)
});